import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: pSEO loan showcase pages. Off-topic finance content on a
// gold/silver rate site; removed as part of the scaled-content cleanup.
export const Route = createFileRoute("/loans/$")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
